<template>
    <div>
        <div class="container">
       
        <br />
        <h4>Highlight Creator</h4>
        <hr />
           <div v-if="isCreating" class="seasoncast-card text-center">
            <h5>Creating Highlight...</h5>
            <br />
            <scale-loader  :color="'darkblue'" ></scale-loader>

            </div>
    <div v-if="recording.session && event && !isCreating" class="seasoncast-card">
  
      
             <PlayerVue  v-if="source" el="player" style="width:100%;" :source="source" :options="options" ref="player" @init="oninit"    ></PlayerVue>

      
            <button @click="setStart" class="btn btn-secondary m-2">Mark current time as Start</button> <button @click="setEnd" class="btn btn-secondary m-2">Mark current time as End</button><br /> <br />
        Highlight Start Time: <strong>{{ highlight.start ? highlight.start  : "Need to mark" | secondsToHms}}</strong><br />
        Highlight End Time: <strong>{{ highlight.end ? highlight.end  : "Need to mark" | secondsToHms}}</strong><br />
<br /> 
  <p >Choose Team:</p>
  <select class="form-control" v-model="teamSelected">
  <option v-for="(team, index) in event.teams" v-bind:value="index" v-bind:key="index">
    {{ team.name }}
  </option>
</select>
<br />
  <p>Title of highlight:</p>
      <input v-model="highlight.title" type="text" class="form-control" placeholder="Name of highlight">
<br />
    <button @click="createHighlight" class="btn btn-lg btn-primary btn-block m-2">Create Highlight</button>
 

        </div>
        <br />
        </div>
    </div>
</template>


<script>
import axios from "axios"
import Swal from "sweetalert2"
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import PlayerVue from './../components/player/PlayerVue.vue'

  var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

   import cookie from "cookie.js"

let API = "https://app.seasoncast.com/"
//let API = "http://localhost:8089/"

export default { 
  name: 'Home',
  props: ['channel'],
  components: {
    ScaleLoader,
    PlayerVue
  },
  
  data: function () {
    return {
        recording: {},
        localclappr: null,
        channel_id: this.$route.params.channel_id,
        highlight: {
            start: undefined,
            end: undefined,
            title: "Highlight",
            display: "public"
        },
        event: undefined,
        teamSelected: 0,
        apiToken: null,
        isCreating: false,
      apiEmail: null,
      source: undefined,
       options: {
        width: "100%",
        height: "100%",
        poster: null,
        mute: false,
        autoplay: !iOS,
        loop: false,
        disable_keyboard_shortcuts: false,
        disable_context_menu: true,
        ga: {},
           controls: iOS,
    
   // chromeless: iOS,
        playback: {
    playInline: true,    
        },
        watermark: {},
        plugins: [],

         markersPlugin: {
    markers: [
    
    ],
    tooltipBottomMargin: 17 // optional
  }
        
      }
    }
  },
    computed: {
    currentTime () {
      return this.$refs.videoPlayer ? this.$refs.videoPlayer.currentTime : undefined
    }
    },
  created: async function () {
   let getViewerToken = cookie.get("viewer-token")
    if (!getViewerToken){
        this.$router.push('/viewer/login?return='+this.$route.fullPath);
        return
    }
  this.apiToken =  cookie.get("viewer-token")
     this.apiEmail =  cookie.get("viewer-email")

await this.getChannelRecording()
this.getRecordingEvent()
this.getChannelEvent(this.recording.event)
  },
  filters: {
 secondsToHms: function(inValue) {
    var d = Number(inValue);

   if (isNaN(d)) {return inValue}
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);

    var hDisplay = h > 0 ? h + (h == 1 ? " hour, " : " hours, ") : "";
    var mDisplay = m > 0 ? m + (m == 1 ? " minute, " : " minutes, ") : "";
    var sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";
    if (d == 0) {return "0 seconds"}
    return hDisplay + mDisplay + sDisplay; 
},
  },
  methods: {
             getRecordingEvent: async function () {
                    console.log(this.recording.session)
         let getResponse = await axios.post(API+ "v2/viewer/watch/recording", {
    channel_id: this.channel_id,
    recording_id: this.recording.session,
    viewer_token: cookie.get("viewer-token"),
    community_password: cookie.get(this.channel_id+"_cp")
  }) 

  let responseData = getResponse.data

  if (!responseData.success){
      //handle api failure

      switch (responseData.reason) {
          case "failure_auth_cp":
              console.log("need cp")

                          await Swal.fire({
  icon: 'error',
  title: 'Watch Error',
  text: 'You need to enter the community password for this channel',
  footer: 'Go to there channel page and enter the CP and try again!'
})

              break;
          case "failure_auth_seasonpass":
              console.log("need auth")
                await Swal.fire({
  icon: 'error',
  title: 'Watch Error',
  text: 'You need to be a SeasonPass Holder to watch this video',
  footer: 'Go to the channel page to get a SeasonPass'
})
              break;
          default:
              break;
      }
      this.$router.push("/"+this.channel_id)
      return
  }
  this.options.poster = responseData.result.poster

  this.source = responseData.result.watch_url[0]
console.log(this.options)
 
        },
   setStart: async function () {
   this.highlight.start = this.localclappr.getCurrentTime()


   if (this.highlight.start > this.highlight.end - 3){
this.highlight.end = this.highlight.start + 3
   }

   if (this.highlight.start < this.highlight.end - 120){
   this.highlight.start = this.highlight.end -  120

   }
   },
    setEnd: async function () {
   this.highlight.end = this.localclappr.getCurrentTime()

   if (this.highlight.start > this.highlight.end - 3){
this.highlight.end = this.highlight.start + 3
   }

   if (this.highlight.start < this.highlight.end - 120){
   this.highlight.start = this.highlight.end -  120

   }

   },
   createHighlight: async function () {
     
     if ((!this.highlight.start) || (!this.highlight.end) || (!this.highlight.title) || (!this.event) ){
Swal.fire(
  'Highlight Create Error',
  'Please enter values for start, end, & name of highlight',
  'error'
)
return
     }
this.isCreating = true
     this.highlight.team = this.event.teams[this.teamSelected || 0]

     this.highlight.origin = { type: "recording", title: this.recording.title, session: this.recording.session, event_id: this.recording.event, channel_id: this.channel_id}
       console.log(this.highlight)

      let getResponse = await axios.post(API+ "v2/viewer/highlight/create", {
         email: this.apiEmail,
    token:  this.apiToken,
    highlight: this.highlight,

  }) 

  let responseData = getResponse.data
this.isCreating = false
  if (!responseData.success){
       await Swal.fire({
  icon: 'error',
  title: 'Error',
  text: 'message: '+JSON.stringify(responseData.reason),
  footer: 'Try action later or refresh page'
})
return
  }
console.log(responseData)
this.$router.push("/highlight/"+responseData.result.id)
   },
     oninit(clappr) {
        this.localclappr = clappr;
     },
    getChannelRecording: async function () {
      
    let getEventResponse = await axios.post(API+ "v2/channel/recording", {
    channel_id: this.$route.params.channel_id,
    recording_id: this.$route.params.recording_id
  }) 

  let responseData = getEventResponse.data

  if (!responseData.success){
       await Swal.fire({
  icon: 'error',
  title: 'Error',
  text: 'message: '+JSON.stringify(responseData.reason),
  footer: 'Try action later or refresh page'
})

  }
console.log(responseData)
  this.recording = responseData.recording
  


    },
       getChannelEvent: async function (event_id) {
      
    let getEventResponse = await axios.post(API+ "v2/channel/event", {
    channel_id:  this.$route.params.channel_id,
    event_id: event_id
  }) 

  let responseData = getEventResponse.data

  if (!responseData.success){
       await Swal.fire({
  icon: 'error',
  title: 'Error',
  text: 'message: '+JSON.stringify(responseData.reason),
  footer: 'Try action later or refresh page'
})

  }
console.log(responseData)
  this.event = responseData.eventData
  
  

    },
  }
}

</script>